var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13335 11.7312L6.99254 2.54518C7.0896 2.36174 7.23484 2.20822 7.41263 2.10115C7.59042 1.99408 7.79403 1.9375 8.00158 1.9375C8.20912 1.9375 8.41273 1.99408 8.59052 2.10115C8.76831 2.20822 8.91355 2.36174 9.01061 2.54518L13.8698 11.7312C13.961 11.9046 14.0058 12.0986 13.9997 12.2944C13.9936 12.4902 13.9369 12.6811 13.8351 12.8484C13.7334 13.0158 13.59 13.1539 13.4189 13.2494C13.2479 13.3449 13.055 13.3944 12.8591 13.3931H3.14184C2.94615 13.394 2.75356 13.3442 2.58282 13.2486C2.41207 13.153 2.26898 13.0148 2.16746 12.8475C2.06593 12.6802 2.00944 12.4894 2.00346 12.2938C1.99748 12.0982 2.04223 11.9044 2.13335 11.7312V11.7312Z",
    stroke: "#FFAB00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.75781V9.03036",
    stroke: "#FFAB00",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99978 11.7574C8.45162 11.7574 8.81791 11.3911 8.81791 10.9392C8.81791 10.4874 8.45162 10.1211 7.99978 10.1211C7.54793 10.1211 7.18164 10.4874 7.18164 10.9392C7.18164 11.3911 7.54793 11.7574 7.99978 11.7574Z",
    fill: "#FFAB00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b775de08.svg";
export { ForwardRef as ReactComponent };